import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppsOverview from '../components/AppsOverview';
import AppDetail from '../components/detail/AppDetail';

const AppsScene = () => (
  <Routes>
    <Route index element={<AppsOverview menuName="apps_plural" />} />
    <Route
      path=":id/:tab?/:installationId?/:view?/:viewId?/:viewPane?"
      element={<AppDetail />}
    />
  </Routes>
);

export default AppsScene;
